export const URI_BASE_API = 'https://uniminasead.com.br/admin/api/'
export const URI_COURSES_API = 'https://uniminasead.com.br/admin/api/'
export const API_VERSION = 'v1'
export const TOKEN_NAME = ''